$(document).ready(function () {
  setTimeout(function () {
    $(".swatch-view-item").each(function () {
      $(this).hover(function () {
        var swatchtext = $(this).find(".swatch-tool-tip-text").text();
        var lastWord = swatchtext.match(/\w+$/)[0];
        $(this).find(".swatch-tool-tip-text").text(lastWord);
      });
    });
  }, 1000);

  // if ($(window).width() < 768) {
  //   $(".slider-for").slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     arrows: true,
  //     fade: true,
  //     asNavFor: ".slider-nav",
  //   });
  //   $(".slider-nav").slick({
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     asNavFor: ".slider-for",
  //     arrows: true,
  //     fade: true,
  //     centerMode: false,
  //     focusOnSelect: true,
  //   });
  // }
});

// header mega menu image hover
$(".dropdown__family .navlink--grandchild").each(function () {
  var $this = $(this);
  $($this).hover(function () {
    $($this)
      .closest(".header__dropdown__inner")
      .find(".menu__blocks .header__dropdown__image")
      .css("visibility", "visible");
    var menuText = $($this).attr("data-handle");
    var menu = $($this).parents(".menu__item").find(".collectionList span");
    $(menu).each(function (index) {
      var listtext = $(this).attr("data-handle");
      if (menuText == listtext) {
        var getImage = $(this).attr("data-image");
        var colImg = $this
          .parents(".header__dropdown")
          .find(".menu__block .image-wrapper img");
        console.log(getImage);
        $(colImg).attr("srcset", getImage);
      }
    });
  });
});

// Producta page tabs sidebar
$(".tab-bar").click(function () {
  $("#tabssidebar").addClass("open");
  $("body").addClass("overflow");
  var tabs = $(this)
    .parents(".product__content")
    .find(".product-tabs .product-tabs-title");
  var overlay = $(this).parents(".product__content").find(".paduct-background");
  var headerclass = $(this)
    .parents(".template-product")
    .find(".header-sections .header__wrapper .theme__header");
  $(tabs).addClass("-fixed");
  $(overlay).addClass("-active");
  $(headerclass).addClass("tabs-index");
});

$(".tabs_sidebar .close-sidebar-btn").click(function () {
  $("#tabssidebar").removeClass("open");
  $("body").removeClass("overflow");
  var tabs = $(this)
    .parents(".product__content")
    .find(".product-tabs .product-tabs-title");
  var overlay = $(this).parents(".product__content").find(".paduct-background");
  var headerclass = $(this)
    .parents(".template-product")
    .find(".header-sections .header__wrapper .theme__header");
  $(tabs).removeClass("-fixed");
  $(overlay).removeClass("-active");
  $(headerclass).removeClass("tabs-index");
});


// ************************* FRIENDS OF OHEN PAGE YOTPO REWARDS APP LOGGED IN CONDITION ****************************

$(document).ready(function() {
  // Select all elements with the class 'element'.
  var bannerTitle = $('.yotpo-text-and-buttons .yotpo-title');
  var bannerDesc = $('.yotpo-text-and-buttons .yotpo-description');
  var bannerSection = $(".yotpo-widget-hero-section.yotpo-widget-override-css");
  
    // Check if the text content of the element is blank.
    if ($(bannerTitle).text().trim() === '' && $(bannerDesc).text().trim() === '') {
      // Set 'display' to 'none' for the element with blank text.
      $(bannerSection).css('display', 'none');
    } else {
      // Set 'display' to 'block' for elements with text.
      $(bannerSection).css('display', 'block');
    }
});


// ************************* You can adjust the scroll value at which the class should be added ****************************
 $(document).ready(function() {
    $(window).scroll(function() {
      if ($(this).scrollTop() > 50) { // You can adjust the scroll value at which the class should be added
        $('body').addClass('scrolled');
      } else {
        $('body').removeClass('scrolled');
      }
    });
  });


//******************** PRODUCT TABS MODAL JS ********************

 $(document).ready(function() {
    var productTab = $(".product-tabs #openSidebarBtn");
   // console.log("productTab", productTab);
   var sideTab = $(".tabs_sidebar .modal-tab-bar");
   // console.log("sideTab", sideTab);
   
  $(productTab).click(function(){
    var triggerButtonId = $(this).data('tab');
     console.log("triggerButtonId", triggerButtonId);
    
    $( ".tabs_sidebar.open #openSidebarBtn" ).each(function( index ) {
    var sideButtonId = $(this).data('tab');
     console.log("sideButtonId", sideButtonId);
       if (triggerButtonId == sideButtonId) {
       var activeTab = $(this);
        $(activeTab).addClass("active");
      }
    });

  });

      $(sideTab).click(function(){
        $(sideTab).removeClass("active");
      });

     setTimeout(function() {
       var closeBtn = $(".tabs_sidebar .close-sidebar-btn");
       $(closeBtn).click(function () {
        $(sideTab).removeClass("active");
      });
     }, 2000);
});

// ******************** NEWSLETTER POPUP JS **************************

$(document).ready(function() {
   setTimeout(function() {
     var classLength = $('body').find('.needsclick.go1272136950').length;
     // console.log('test area',classLength);
    if (classLength == 1) {
       $('body').addClass('popup');
      // console.log('class found in the body');
    }
     $('.klaviyo-close-form').click(function () {
       // console.log('close button');
       $('body').removeClass('popup');
     });
  }, 1000); 
});
